import { createFrontendPlugin, PageBlueprint } from '@backstage/frontend-plugin-api';
import { RiGithubFill } from '@remixicon/react';
import { rootRouteRef } from './routes';

export const githubPage = PageBlueprint.make({
  params: {
    path: '/github-repositories',
    routeRef: rootRouteRef,
    loader: () => import('./components/RepositoriesPage').then(m => <m.RepositoriesPage />),
  },
});

export default createFrontendPlugin({
  pluginId: 'github-repositories',
  title: 'Repositories',
  icon: <RiGithubFill />,
  extensions: [githubPage],
  routes: {
    root: rootRouteRef,
  },
});
